/**
 * WOM boot priority.
 *
 * Top-of-page video widgets (story rings + video gallery cards) must win the
 * network race. Instagram and other below-fold WOM work wait until those
 * rails have painted (or a safety timeout), then run on idle.
 *
 * Also kicks the video API fetches as early as this script runs, so the
 * responses are already in flight while the rest of the page is still
 * parsing. Widget scripts reuse those in-flight promises instead of
 * starting a second request.
 */
(function () {
  'use strict';

  if (window.WOMPriority) return;

  var PERF = window.WOMPerf || { mark: function () {} };
  var SAFETY_MS = 4500;
  var expected = {};
  var done = {};
  var waiters = [];
  var released = false;
  var earlyFetches = {};

  function nowDetail() {
    return { readyState: document.readyState };
  }

  function allExpectedDone() {
    var keys = Object.keys(expected);
    if (!keys.length) return false;
    for (var i = 0; i < keys.length; i++) {
      if (!done[keys[i]]) return false;
    }
    return true;
  }

  function flushWaiters() {
    if (released) return;
    released = true;
    PERF.mark('boot-priority', 'TOP VIDEO PRIORITY RELEASED — deferred work may start', nowDetail());
    var queue = waiters.slice();
    waiters = [];
    queue.forEach(function (fn) {
      try {
        fn();
      } catch (e) {}
    });
  }

  function maybeRelease() {
    if (released) return;
    if (allExpectedDone()) flushWaiters();
  }

  function runWhenIdle(fn) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(function () {
        fn();
      }, { timeout: 2000 });
      return;
    }
    window.setTimeout(fn, 200);
  }

  function expect(name) {
    if (!name) return;
    expected[name] = true;
    PERF.mark('boot-priority', 'expecting ' + name);
  }

  function markDone(name) {
    if (!name) return;
    done[name] = true;
    PERF.mark('boot-priority', name + ' painted / ready');
    maybeRelease();
  }

  /**
   * Deferred callers (Instagram, etc.) register here. They run only after
   * every expected top-video widget has called markDone(), or after SAFETY_MS.
   */
  function whenTopVideosReady(fn) {
    if (typeof fn !== 'function') return;
    if (released) {
      runWhenIdle(fn);
      return;
    }
    waiters.push(function () {
      runWhenIdle(fn);
    });
  }

  function earlyFetch(key, url, init) {
    if (!key || !url) return null;
    if (earlyFetches[key]) return earlyFetches[key];

    PERF.mark('boot-priority', 'early fetch started: ' + key, { url: url });
    // Resolve to parsed JSON (not the Response). A Response body can only be
    // read once, and the widget that reuses this must not fight a second reader.
    var promise = fetch(
      url,
      init || {
        headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' },
        cache: 'no-store'
      }
    ).then(function (r) {
      if (!r.ok) throw new Error('Early fetch failed: ' + r.status + ' for ' + key);
      return r.json();
    }).catch(function (err) {
      delete earlyFetches[key];
      throw err;
    });

    earlyFetches[key] = promise;
    return promise;
  }

  function takeEarlyFetch(key) {
    return earlyFetches[key] || null;
  }

  window.WOMPriority = {
    expect: expect,
    markDone: markDone,
    whenTopVideosReady: whenTopVideosReady,
    earlyFetch: earlyFetch,
    takeEarlyFetch: takeEarlyFetch,
    runWhenIdle: runWhenIdle,
    isReleased: function () {
      return released;
    }
  };

  // Homepage top widgets. Product/collection pages can add more via expect().
  var path = (window.location && window.location.pathname) || '/';
  var isHome = path === '/' || path === '';

  if (isHome) {
    expect('video-gallery');

    var galleryUrl =
      'https://api.thewordofmouth.in/api/video/videos/inhanssv1?category=company_videos';
    PERF.mark('boot-priority', 'starting gallery API early');
    var galleryPromise = earlyFetch('videos:gallery', galleryUrl);
    if (window.WOMVideoFeed && window.WOMVideoFeed.put) {
      window.WOMVideoFeed.put(galleryUrl, galleryPromise);
    }
  }

  window.setTimeout(function () {
    if (!released) {
      PERF.mark('boot-priority', 'safety timeout — releasing deferred work', {
        done: Object.keys(done),
        expected: Object.keys(expected)
      });
      flushWaiters();
    }
  }, SAFETY_MS);

  PERF.mark('boot-priority', 'scheduler ready', nowDetail());
})();
